"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomFields = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable import/prefer-default-export */

const CustomFields = _ref => {
  let {
    inputType,
    fieldName,
    watching,
    expecting,
    defaultValue,
    label,
    options = [],
    config = {},
    otherOptions = {},
    controlError,
    UI,
    handler,
    handleDataUpdates,
    handleNavigation,
    fieldFactory,
    original,
    parent
  } = _ref;
  const {
    register,
    control
  } = (0, _reactHookForm.useFormContext)({
    mode: 'all'
  });
  const field = {
    inputType,
    fieldName,
    watching,
    expecting,
    defaultValue,
    label,
    options,
    config,
    otherOptions,
    UI,
    handler,
    original,
    parent
  };
  return fieldFactory ? /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: field.fieldName,
    defaultValue: field.defaultValue,
    watching: field.watching,
    expecting: field.expecting,
    control: control,
    rules: field.config,
    handler: field.handler,
    render: _ref2 => {
      let {
        field: {
          onChange
        }
      } = _ref2;
      return fieldFactory(field, controlError, handleDataUpdates, register, control, onChange, handleNavigation);
    }
  }) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
};
exports.CustomFields = CustomFields;
CustomFields.propTypes = {
  fieldFactory: _propTypes.default.func,
  inputType: _propTypes.default.string.isRequired,
  fieldName: _propTypes.default.string.isRequired,
  watching: _propTypes.default.string,
  expecting: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.array, _propTypes.default.object]),
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool, _propTypes.default.array, _propTypes.default.object]),
  label: _propTypes.default.string,
  options: _propTypes.default.array,
  config: _propTypes.default.object,
  otherOptions: _propTypes.default.object,
  controlError: _propTypes.default.string,
  handleDataUpdates: _propTypes.default.func,
  UI: _propTypes.default.object,
  handler: _propTypes.default.string,
  original: _propTypes.default.object,
  parent: _propTypes.default.object
};
//# sourceMappingURL=CustomFields.js.map